export default {
  header: {
    title: 'IdeIHM Instituto Hidrográfico de la Marina',
  },
  visor: {
    coordinates: 'Coordinates',
    map: 'Map',
    image: 'Image',
    street_map: 'Street map',
    base_layer: 'Base layer',
    marine: 'Marine-Geo',
    termycondition: 'Legal Advice',
    about: 'About',
    portal: 'Go to the portal',
    extend: 'Zoom to the extent of the map',
    help: 'Use manual'
  },
};
